import React from 'react'
import { SVGIconProps } from '../types'
const SvgMinimize = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M6 19h12v2H6z" />
  </svg>
)
export default SvgMinimize
